var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFormIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "form_icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21.993v23.992H0z",
  "data-name": "Rectangle 6225"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14070"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13958"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13957"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.545 10.779h10.911",
  "data-name": "Line 1200"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.545 19.221h10.911",
  "data-name": "Line 1201"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M9.545 15h10.911",
  "data-name": "Line 1202"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13956"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#form_icon_svg__a)",
  "data-name": "Group 13955",
  transform: "translate(4.004 3.004)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13.995 22.992c5 0 7-3 7-8V9c0-5-2-8-7-8H8C3 1 1 4 1 9v6c0 5 2 8 7 8Z",
  "data-name": "Path 16527"
}))))), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 54"
}))));
export { SvgFormIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/form_icon.76c419f0b93a7d6a9cb42f5b8dda7366.svg";